import { render, staticRenderFns } from "./sales-order-items-editor.vue?vue&type=template&id=748a7f7a&scoped=true&"
import script from "./sales-order-items-editor.vue?vue&type=script&lang=js&"
export * from "./sales-order-items-editor.vue?vue&type=script&lang=js&"
import style0 from "./sales-order-items-editor.vue?vue&type=style&index=0&id=748a7f7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748a7f7a",
  null
  
)

export default component.exports